interface MemberApplicationAddress {
    street?: string;
    city?: string;
    post?: string;
    zipCode?: string;
}
const MemberApplicationAddressDefaults: MemberApplicationAddress = {
    street: null,
    city: null,
    post: null,
    zipCode: null
}

interface MemberApplicationMember {
    name?: string;
    surname?: string;
    title?: string;
    birthDate?: Date;
    sex?: string;
    personalIdNumber?: string;
    country?: string;
    countryName?: string;
    homeAddress: MemberApplicationAddress;
    postAddress: MemberApplicationAddress;
    email?: string;
    ownedIdt?: number;
    mobilePhone?: string;
    employerPhone?: string;
    homePhone?: string;
}
const MemberApplicationMemberDefaults: MemberApplicationMember = {
    name: null,
    surname: null,
    title: null,
    birthDate: null,
    sex: null,
    personalIdNumber: null,
    country: null,
    countryName: null,
    homeAddress: MemberApplicationAddressDefaults,
    postAddress: MemberApplicationAddressDefaults,
    email: null,
    ownedIdt: null,
    mobilePhone: null,
    employerPhone: null,
    homePhone: null
}

interface MemberApplicationLegalRepresentative {
    name?: string;
    surname?: string;
    title?: string;
    birthDate?: Date;
    homeAddress: MemberApplicationAddress;
    postAddress: MemberApplicationAddress;
    email?: string;
    mobilePhone?: string;
    employerPhone?: string;
    homePhone?: string;
}
const MemberApplicationLegalRepresentativeDefaults: MemberApplicationLegalRepresentative = {
    name: null,
    surname: null,
    title: null,
    birthDate: null,
    homeAddress: MemberApplicationAddressDefaults,
    postAddress: MemberApplicationAddressDefaults,
    email: null,
    mobilePhone: null,
    employerPhone: null,
    homePhone: null
}

enum MemberApplicationState {
    BeingEdited = 0,
    Submitted = 1,
    Approved = 2,
    Cancelled = 3,
}

const CzechNamingOfMemberApplicationState = (state: MemberApplicationState) =>
{
    if (state == MemberApplicationState.BeingEdited){
        return "Rozpracováno";
    }
    if (state == MemberApplicationState.Submitted){
        return "Odesláno";
    }
    if (state == MemberApplicationState.Approved){
        return "Schváleno";
    }
    if (state == MemberApplicationState.Cancelled){
        return "Zrušeno";
    }
    return "";
}

enum MemberApplicationFormState {
    None = 0,
    StatutesAgreement = 1,
    VerificationAgreement = 2,
    MemberPostAddressIsSameAsHome = 4,
    LegalRepHomeAddressIsSameAsMember = 8,
    LegalRepPostAddressIsSameAsHome = 16,
    LoggedUserIsSameAsMember = 32,
    LoggedUserIsOtherMember = 64,
    IsEmailVerification = 128,
    IsPhoneVerification = 256,
    HasLegalRepresentative = 512,
}


interface MemberApplication {
    id: number;
    state: MemberApplicationState;
    hashCode: string;
    applicationNumber?: number;
    clubId?: number;
    club?: string;
    member: MemberApplicationMember;
    legalRepresentative: MemberApplicationLegalRepresentative;
    formFlags: MemberApplicationFormState;
}
const MemberApplicationDefaults: MemberApplication = {
    id: 0,
    state: MemberApplicationState.BeingEdited,
    hashCode: "",
    applicationNumber: null,
    club: null,
    clubId: null,
    member: MemberApplicationMemberDefaults,
    legalRepresentative: MemberApplicationLegalRepresentativeDefaults,
    formFlags:
        MemberApplicationFormState.MemberPostAddressIsSameAsHome |
        MemberApplicationFormState.LegalRepHomeAddressIsSameAsMember |
        MemberApplicationFormState.LegalRepPostAddressIsSameAsHome
}

export {
    MemberApplication,
    MemberApplicationDefaults,
    MemberApplicationMember,
    MemberApplicationAddress,
    MemberApplicationLegalRepresentative,
    MemberApplicationFormState,
    MemberApplicationState,
    CzechNamingOfMemberApplicationState
}
